// 右下角操作框 store : 上传、解压和压缩
import OperateState from './types'
export default {
    namespaced: true,
    state: {
        // taskListBox: 'fold-task', // 默认状态
        // uploadFileLength: 0,
        // dialogUnZipData: [],
        // dialogCompressData: [],

        // activeTabName: 'upload',

        // isShowLoad: false, // 弹窗展示


        // 上传相关参数：
        dragUploadFiles: [], // 拖拽上传,fileId
        openFilePath: false // 页面打开选择文件
    },
    mutations: {
        // SET_UNZIP_DATA(state: OperateState, data: UnzipListItem[] ) {
        //     state.dialogUnZipData = data
        // },
        // SET_COMPRESS_DATA(state: OperateState, data: CompressListItem[] ) {
        //     state.dialogCompressData = data
        // },
        SET_DRAGUPLOAD_DATA(state: OperateState, data: File[]) {
            state.dragUploadFiles = data
        },
        SET_OPENFILEPATH_DATA(state: OperateState){
            state.openFilePath = !state.openFilePath
        }
    }
}
   
